import React from 'react';
import { useTheme } from 'styled-components';

/**
 * Un botón reutilizable. En modo oscuro usa un color sólido; en modo claro usa gradiente.
 */
const GradientButton = ({
  onPress,
  disabled = false,
  loading = false,
  children,
  style = {},
  colors = ['#111111', '#1B8390']
}) => {
  const theme = useTheme();

  const background = theme.isDark
    ? '#ffffff'
    : `linear-gradient(to right, ${colors[0]}, ${colors[1]})`;

  const textColor = theme.isDark ? '#000000' : '#ffffff';

  const gradientStyle = {
    background,
    color: textColor,
    padding: '13px 20px',
    borderRadius: '10px',
    border: 'none',
    fontWeight: '600',
    fontSize: '16px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    width: '100%',
    boxShadow: theme.isDark
      ? 'none'
      : '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    transition: 'all 0.2s ease',
    opacity: disabled ? 0.5 : 1,
    ...style,
  };

  return (
    <button
      className={`gradient-button ${disabled ? 'button-disabled' : ''}`}
      style={gradientStyle}
      onClick={onPress}
      disabled={disabled || loading}
    >
      {children}
    </button>
  );
};

export default GradientButton;
